module.exports = __webpack_public_path__ + "static/GreatRoomLiving-89d7c8d43d7551c26b6e6cf04745235e.jpg";